import type Cookies from 'js-cookie';

import type { TrackingEvent } from './types';

export function isLoggingEnabled(cookies: Cookies.CookiesStatic, def: boolean): boolean {
	const exp = cookies.get('event_logging');
	if (exp === undefined) {
		return def;
	}
	return exp === 'true';
}

export function toggleLogging(cookies: Cookies.CookiesStatic, enabled: boolean): void {
	if (enabled) {
		cookies.set('event_logging', 'true');
		return;
	}
	cookies.remove('event_logging');
}

export function logEvents(events: readonly TrackingEvent[], common: Record<string, unknown>, silenced: boolean): void {
	events.forEach((event) => {
		/* eslint-disable no-console */
		console.groupCollapsed(`%cTRACKED EVENT:%c ${event.name}`, 'color: green', 'color: default');
		console.log('event data:', event.data);
		if (event.defaultOverrides && Object.keys(event.defaultOverrides).length) {
			console.log('default overrides:', event.defaultOverrides);
		}
		console.log('full data:', { ...common, ...event.data, ...event.defaultOverrides });
		console.log('silenced:', silenced);
		console.groupEnd();
		/* eslint-enable no-console */
	});
}
